<template>
  <div class="m-0 dbozone-font bg-veggiesbonanza" :class="`${lang}-font`">
    <div class="container d-flex flex-column justify-content-center">
      <div class="d-flex flex-column nav-bonanza">
        <section class="d-flex p-2 justify-content-center">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -veggiesbonanza`">{{ $t('3_5_bonus_20.paytable.symtable_title') }}</h5>
        </section>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row mt-4 nav-special-symbols">
        <div class="col-3 p-0 d-flex align-items-center">
          <img class="icon-paytable" :src="require(`../../assets/resultGame/veggiesbonanza/symbol_9.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-1 align-items-center justify-content-center">
          <span class=" text-sub" :class="`-${lang}`">
            {{'6 - ' + paytable[9][5]}} <br>
            {{'5 - ' + paytable[9][4]}} <br>
            {{'4 - ' + paytable[9][3]}}
          </span>
        </div>
        <div class="col-6 d-flex align-items-center p-0 ml-2 justify-content-center">
          <span class="font-weight-bold text-sub" :class="`-${lang}`">{{$t('veggiesbonanza.paytable.symtable_scatter')}}
          </span>
        </div>
      </div>

      <div class="col-12 mt-3 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/veggiesbonanza/symbol_10.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">
            {{$t('veggiesbonanza.multiplier.title')}} <br>
            {{' x3 - x100'}}
          </span>
        </div>
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/veggiesbonanza/symbol_8.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">
            {{'(12+) - ' + paytable[8][11]}} <br>
            {{'10,11 - ' + paytable[8][10]}} <br>
            {{'8,9 - ' + paytable[8][8]}}
          </span>
        </div>
      </div>

      <div class="col-12 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/veggiesbonanza/symbol_7.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">
            {{'(12+) - ' + paytable[7][11]}} <br>
            {{'10,11 - ' + paytable[7][10]}} <br>
            {{'9,8 - ' + paytable[7][8]}}
          </span>
        </div>
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/veggiesbonanza/symbol_6.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">
            {{'(12+) - ' + paytable[6][11]}} <br>
            {{'10,11 - ' + paytable[6][10]}} <br>
            {{'8,9 - ' + paytable[6][8]}}
          </span>
        </div>
      </div>

      <div class="col-12 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/veggiesbonanza/symbol_5.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">
            {{'(12+) - ' + paytable[5][11]}} <br>
            {{'10,11 - ' + paytable[5][10]}} <br>
            {{'8,9 - ' + paytable[5][8]}}
          </span>
        </div>
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/veggiesbonanza/symbol_4.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">
            {{'(12+) - ' + paytable[4][11]}} <br>
            {{'10,11 - ' + paytable[4][10]}} <br>
            {{'8,9 - ' + paytable[4][8]}}
          </span>
        </div>
      </div>

      <div class="col-12 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/veggiesbonanza/symbol_3.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">
            {{'(12+) - ' + paytable[3][11]}} <br>
            {{'10,11 - ' + paytable[3][10]}} <br>
            {{'8,9 - ' + paytable[3][8]}}
          </span>
        </div>
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/veggiesbonanza/symbol_2.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">
            {{'(12+) - ' + paytable[2][11]}} <br>
            {{'10,11 - ' + paytable[2][10]}} <br>
            {{'8,9 - ' + paytable[2][8]}}
          </span>
        </div>
      </div>
      
      <div class="col-12 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/veggiesbonanza/symbol_1.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">
            {{'(12+) - ' + paytable[1][11]}} <br>
            {{'10,11 - ' + paytable[1][10]}} <br>
            {{'8,9 - ' + paytable[1][8]}}
          </span>
        </div>
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/veggiesbonanza/symbol_0.png`)"
          alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 align-items-center ml-2">
          <span class=" text-sub" :class="`-${lang}`">
            {{'(12+) - ' + paytable[0][11]}} <br>
            {{'10,11 - ' + paytable[0][10]}} <br>
            {{'8,9 - ' + paytable[0][8]}}
          </span>
        </div>
      </div>

      <div class="col-12 mt-3 justify-content-left d-flex flex-column mt-5">
        <div class="d-flex p-2 mt-1">
          <span class=" m-0 text-sub" :class="`-${lang}`">
            <li>{{ $t('veggiesbonanza.paytable.symtable_desc') }}</li>
          </span>
        </div>
      </div>

      <div class="d-flex flex-column nav-bonanza mt-4">
        <section class="d-flex p-2 justify-content-center">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -veggiesbonanza`">{{ $t('veggiesbonanza.featurebuy.title') }}</h5>
        </section>
      </div>
      <div class="d-flex p-2 mt-1 mb-2 justify-content-center">
        <img class="mt-3 icon-startbutton" :src="require(`../../assets/paytable/veggiesbonanza/feature_buy_${imgLang}.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`"><li>{{ $t('veggiesbonanza.featurebuy.text1') }}</li></span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`"><li>{{ $t('veggiesbonanza.featurebuy.text2') }}</li></span>
      </div>

      <div class="d-flex flex-column nav-bonanza mt-4">
        <section class="d-flex p-2 justify-content-center">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -veggiesbonanza`">{{ $t('veggiesbonanza.freespin.title') }}</h5>
        </section>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row mt-4">
        <div class="justify-content-center d-flex flex-row">
          <img class="mt-3 mb-5 icon-paytable" :src="require(`../../assets/paytable/veggiesbonanza/scatter.png`)"
          alt="">
        </div>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`"><li>{{ $t('veggiesbonanza.freespin.desc1') }}</li></span>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row mt-4">
        <div class="justify-content-center d-flex flex-row">
          <img class="mt-3 mb-5 icon-paytable" :src="require(`../../assets/paytable/veggiesbonanza/gold_framed_symbols.png`)"
          alt="">
        </div>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`"><li>{{ $t('veggiesbonanza.freespin.desc3') }}</li></span>
      </div>

      <div class="d-flex flex-column nav-bonanza mt-4 mb-4">
        <section class="d-flex p-2 justify-content-center">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -veggiesbonanza`">{{ $t('veggiesbonanza.way.title') }}</h5>
        </section>
      </div>
      <div class="d-flex p-2 mb-1">
        <span class="m-0  text-sub"><li>{{ $t('veggiesbonanza.way.desc1') }}</li></span>
      </div>
      <div class="justify-content-center d-flex flex-col">
          <img class="mt-3 mb-5 icon-paytable" :src="require(`../../assets/paytable/veggiesbonanza/line_paytable.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 mb-1">
        <span class="m-0  text-sub"><li>{{ $t('veggiesbonanza.way.desc2') }}</li></span>
      </div>

      <div class="d-flex p-2 mb-1">
        <span class="m-0  text-sub"><li>{{ $t('veggiesbonanza.way.desc4') }}</li></span>
      </div>
      <div class="d-flex p-2 mb-1">
        <span class="m-0  text-sub"><li>{{ $t('veggiesbonanza.way.desc5') }}</li></span>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'paytable-veggiesbonanza',
  props: {
    data: Object,
    lang: String,
    imgLang: String
  },
  data() {
    return {
      paytable: this.data.config.payTable
    }
  }
}
</script>

<style>

.icon-paytable {
  width: 100%;
}
.nav-special-symbols {
  border-color: #A7CC2D;
  border-style: solid;
  border-radius: 15px;
  border-width: thick;
}

.bg-veggiesbonanza {
  background:#432615;
}

.nav-bonanza {
  background: #A7CC2D;
  border-radius: 10px;
}

.content {
  background: #000013;
  height: 100%;
  /* width: 100%; */
  background-size:cover;
  background-attachment: scroll;
  background-repeat: no-repeat;
}

@media screen and (max-width: 768px) {
  .header > div {
    flex-grow: 0;
    width: 33.33%;
  }
}

</style>